// Elv3config.js

export const inspectionTypeOptions = {
  "1": { id: "1", type: "1 Year Test / Category 1", isCat1: true },
  "3": { id: "3", type: "5 Year Test / Category 5", isCat1: false },
  "7": { id: "7", type: "Periodic Inspection", isCat1: false },
};

// For isItPrivateResidence => stored at the top-level key "IsItPrivateResidence"
export const privateResidence = [
  { key: 'IsItPrivateResidence', label: 'Is it a private residence?', type: 'checkbox' },
];

export const inspectionFields = [
  { key: 'IsCat1', label: 'Is Cat 1', type: 'checkbox' },
  { key: 'IsCat5', label: 'Is Cat 5', type: 'checkbox' },
  { key: 'InspectionType', label: 'Inspection Type', type: 'select', options: ['1 Year Test / Category 1', '5 Year Test / Category 5', 'Periodic Inspection'] },
  { key: 'DeviceID', label: 'Device ID', type: 'text' },
  { key: 'DeviceStatus', label: 'Device Status', type: 'select', options: ['Active', 'Inactive'] },
  { key: 'DeviceTypeLabel', label: 'Device Type', type: 'select', options: ['Elevator'] },
  { key: 'InspectionDate', label: 'Inspection Date', type: 'date' },
  { key: 'DeviceGuid', label: 'Device GUID', type: 'text' },
  { key: 'ViolationDate', label: 'Violation Date', type: 'date' },
];

// Applicant => "ApplicantInformation"
export const applicantFields = [
  { key: 'ApplicantGuid', label: 'Applicant GUID', type: 'text' },
  { key: 'BusinessAddress', label: 'Business Address', type: 'text' },
  { key: 'BusinessFax', label: 'Business Fax', type: 'text' },
  { key: 'BusinessName', label: 'Business Name', type: 'text' },
  { key: 'BusinessTelephne', label: 'Business Telephone', type: 'text' },
  { key: 'City', label: 'City', type: 'text' },
  { key: 'Email', label: 'Email', type: 'text' }, // Email lookup possible here
  { key: 'FirstName', label: 'First Name', type: 'text' },
  { key: 'FullName', label: 'Full Name', type: 'text' },
  { key: 'LastName', label: 'Last Name', type: 'text' },
  { key: 'MI', label: 'Middle Initial', type: 'text' },
  { key: 'Mobile', label: 'Mobile', type: 'text' },
  { key: 'State', label: 'State', type: 'text' },
  { key: 'Zip', label: 'Zip Code', type: 'text' },
];

// Owner => "OwnerInformation"
export const ownerFields = [
  { key: 'BusinessName', label: 'Business Name', type: 'text' },
  { key: 'BusinessPhone', label: 'Business Phone', type: 'text' },
  { key: 'City', label: 'City', type: 'text' },
  { key: 'ContactGuid', label: 'Contact GUID', type: 'text' },
  { key: 'Email', label: 'Email', type: 'text' }, // Email lookup possible here
  { key: 'FirstName', label: 'First Name', type: 'text' },
  { key: 'Fullname', label: 'Full Name', type: 'text' },
  { key: 'LastName', label: 'Last Name', type: 'text' },
  { key: 'LicenseList', label: 'License List', type: 'array' },
  { key: 'MiddleName', label: 'Middle Name', type: 'text' },
  { key: 'Mobile', label: 'Mobile', type: 'text' },
  { key: 'OwnerType', label: 'Owner Type', type: 'select', options: ['1'] },
  { key: 'State', label: 'State', type: 'text' },
  { key: 'Street', label: 'Street', type: 'text' },
  { key: 'Zip', label: 'Zip Code', type: 'text' },
];

// Location => "LocationInformation"
export const locationFields = [
  { key: 'Bin', label: 'BIN', type: 'text' },
  { key: 'Block', label: 'Block', type: 'text' },
  { key: 'Borough', label: 'Borough', type: 'text' },
  { key: 'HouseNumber', label: 'House Number', type: 'text' },
  { key: 'Lot', label: 'Lot', type: 'text' },
  { key: 'StreetName', label: 'Street Name', type: 'text' },
  { key: 'ZipCode', label: 'Zip Code', type: 'text' },
];

// Witness => "Witness"
export const witnessFields = [
  { key: 'Witness', label: 'Witness Info (JSON)', type: 'object' },
];

// Director => "PerformingAgencyDirectorInformation"
export const directorFields = [
  { key: 'BusinessName', label: 'Business Name', type: 'text' },
  { key: 'BusinessPhone', label: 'Business Phone', type: 'text' },
  { key: 'City', label: 'City', type: 'text' },
  { key: 'ContactGuid', label: 'Contact GUID', type: 'text' },
  { key: 'Email', label: 'Email', type: 'text' },
  { key: 'FirstName', label: 'First Name', type: 'text' },
  { key: 'Fullname', label: 'Full Name', type: 'text' },
  { key: 'LastName', label: 'Last Name', type: 'text' },
  { key: 'LicenseList', label: 'License List', type: 'array' },
  { key: 'MiddleName', label: 'Middle Name', type: 'text' },
  { key: 'Mobile', label: 'Mobile', type: 'text' },
  { key: 'OwnerType', label: 'Owner Type', type: 'text' },
  { key: 'State', label: 'State', type: 'text' },
  { key: 'Street', label: 'Street', type: 'text' },
  { key: 'Zip', label: 'Zip Code', type: 'text' },
];

// Inspector => "PerformingAgencyInspectorInformation"
export const inspectorFields = [
  { key: 'BusinessName', label: 'Business Name', type: 'text' },
  { key: 'BusinessPhone', label: 'Business Phone', type: 'text' },
  { key: 'City', label: 'City', type: 'text' },
  { key: 'ContactGuid', label: 'Contact GUID', type: 'text' },
  { key: 'Email', label: 'Email', type: 'text' },
  { key: 'FirstName', label: 'First Name', type: 'text' },
  { key: 'Fullname', label: 'Full Name', type: 'text' },
  { key: 'LastName', label: 'Last Name', type: 'text' },
  { key: 'LicenseList', label: 'License List', type: 'array' },
  { key: 'MiddleName', label: 'Middle Name', type: 'text' },
  { key: 'Mobile', label: 'Mobile', type: 'text' },
  { key: 'OwnerType', label: 'Owner Type', type: 'text' },
  { key: 'State', label: 'State', type: 'text' },
  { key: 'Street', label: 'Street', type: 'text' },
  { key: 'Zip', label: 'Zip Code', type: 'text' },
];

// Email Lookup Configuration for EmailLookupGrid
export const emailDisplayConfig = [
  {
    section: 'ApplicantInformation',
    title: 'Applicant Information',
    fields: [
        { label: 'Email', key: 'Email' },
        { label: 'Business Name', key: 'BusinessName' },
        { label: 'Business Phone', key: 'BusinessTelephne' },
        { label: 'City', key: 'City' },
        { label: 'First Name', key: 'FirstName' },
        { label: 'Last Name', key: 'LastName' },
    ],
  },
  {
    section: 'OwnerInformation',
    title: 'Owner Information',
    fields: [
      { label: 'Email', key: 'Email' },
      { label: 'Business Name', key: 'BusinessName' },
      { label: 'Business Phone', key: 'BusinessPhone' },
      { label: 'City', key: 'City' },
      { label: 'First Name', key: 'FirstName' },
      { label: 'Last Name', key: 'LastName' },
    ],
  },
  {
    section: 'PerformingAgencyDirectorInformation',
    title: 'Director Information',
    fields: [
        { label: 'Email', key: 'Email' },
        { label: 'Business Name', key: 'BusinessName' },
        { label: 'Business Phone', key: 'BusinessPhone' },
        { label: 'City', key: 'City' },
        { label: 'First Name', key: 'FirstName' },
        { label: 'Last Name', key: 'LastName' },
    ],
  },
  {
    section: 'PerformingAgencyInspectorInformation',
    title: 'Inspector Information',
    fields: [
        { label: 'Email', key: 'Email' },
        { label: 'Business Name', key: 'BusinessName' },
        { label: 'Business Phone', key: 'BusinessPhone' },
        { label: 'City', key: 'City' },
        { label: 'First Name', key: 'FirstName' },
        { label: 'Last Name', key: 'LastName' },
    ],
  },
];
